import {colors, Colors} from '@microfrontends/react-components'
import React from 'react'
import { PageTitleText } from './styles'

interface IProps {
	subItem?: React.ReactNode
	children?: React.ReactNode
	light?: boolean
	id?: string
}

const SectionTitle: React.FC<IProps> = ({  children, light, id, subItem}) => {
	return (
		<PageTitleText light={light} id={id || ''}>
			{children}
			{subItem || null}
		</PageTitleText>
	)
}

export default SectionTitle
